module.exports = __webpack_public_path__ + "assets/certificate_pdf/Adobe Premiere CC_Silicon Stone Education_20210720.4774f7e8.pdf";